export class DetectorSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "detectorType",
            "baseName": "detectorType",
            "type": "DetectorSummaryDetectorTypeEnum",
            "format": ""
        },
        {
            "name": "conclusion",
            "baseName": "conclusion",
            "type": "DetectorSummaryConclusionEnum",
            "format": ""
        },
        {
            "name": "counts",
            "baseName": "counts",
            "type": "Array<FindingCountEntry>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DetectorSummary.attributeTypeMap;
    }
    constructor() {
    }
}
export var DetectorSummaryDetectorTypeEnum;
(function (DetectorSummaryDetectorTypeEnum) {
    DetectorSummaryDetectorTypeEnum["Malware"] = "MALWARE";
    DetectorSummaryDetectorTypeEnum["RansomwareBehavior"] = "RANSOMWARE_BEHAVIOR";
    DetectorSummaryDetectorTypeEnum["DataAnomaly"] = "DATA_ANOMALY";
    DetectorSummaryDetectorTypeEnum["AiDataRisk"] = "AI_DATA_RISK";
    DetectorSummaryDetectorTypeEnum["DataExposureRisk"] = "DATA_EXPOSURE_RISK";
    DetectorSummaryDetectorTypeEnum["VulnerableApplication"] = "VULNERABLE_APPLICATION";
})(DetectorSummaryDetectorTypeEnum || (DetectorSummaryDetectorTypeEnum = {}));
export var DetectorSummaryConclusionEnum;
(function (DetectorSummaryConclusionEnum) {
    DetectorSummaryConclusionEnum["Clean"] = "CLEAN";
    DetectorSummaryConclusionEnum["HighChanceForRansomware"] = "HIGH_CHANCE_FOR_RANSOMWARE";
    DetectorSummaryConclusionEnum["DataAnomalyDetected"] = "DATA_ANOMALY_DETECTED";
    DetectorSummaryConclusionEnum["MalwareDetected"] = "MALWARE_DETECTED";
    DetectorSummaryConclusionEnum["AiDataRiskDetected"] = "AI_DATA_RISK_DETECTED";
    DetectorSummaryConclusionEnum["DataExposureRiskDetected"] = "DATA_EXPOSURE_RISK_DETECTED";
    DetectorSummaryConclusionEnum["VulnerableApplicationDetected"] = "VULNERABLE_APPLICATION_DETECTED";
})(DetectorSummaryConclusionEnum || (DetectorSummaryConclusionEnum = {}));
